import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/user/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { PasswordComponent } from './components/user/password/password.component';
import { ReintegrosComponent } from './components/reintegros/reintegros.component';
import { ReportesComponent } from './components/reportes/reportes.component';
import { PqrComponent } from './components/pqr/pqr.component';
import { CargaComponent } from './components/carga/carga.component';
import { PersonalizacionComponent } from './components/personalizacion/personalizacion.component';
import { ForgotComponent } from './components/user/forgot/forgot.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PaymentsComponent } from './pages/payments/payments.component';
import { ReportsChartsPageComponent } from './pages/report-charts-page/report-charts-page.component';


const APP_ROUTES: Routes = [

    { path: 'login', component: LoginComponent },
    { path: 'password', component: PasswordComponent },
    { path: 'forgot', component: ForgotComponent },
    { path: 'personalizacion', component: PersonalizacionComponent, canActivate: [AuthGuard] },
    { path: 'facturas', component: ReintegrosComponent },
    { path: 'pagos', component: PaymentsComponent, canActivate: [AuthGuard] },
    { path: 'not-found', component: NotFoundComponent },
    // { path: 'reportes', component: ReportesComponent },
    { path: 'reportes', component: ReportsChartsPageComponent, canActivate: [AuthGuard] },
    { path: 'pqr', component: PqrComponent, canActivate: [AuthGuard] },
    { path: 'carga', component: CargaComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'login' },
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, { useHash: true, anchorScrolling: 'enabled' });
